import request from '@/providers/http-service'
import qs from 'qs'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`
// const url = `http://tu4u59.natappfree.cc`

/**
 * 点位类型管理
 * start
 */
// 分页查询点位类型列表
export function getPointTypeListPage(params) {
  return request({
    url: url + '/gh-point-type/getPointTypeListPage',
    method: 'post',
    data: params
  })
}
// 添加点位类型
export function addPointType(params) {
  return request({
    url: url + '/gh-point-type/addPointType',
    method: 'post',
    data: params
  })
}
// 修改点位类型
export function updatePointType(params) {
  return request({
    url: url + '/gh-point-type/updatePointType',
    method: 'post',
    data: params
  })
}
// 删除点位类型
export function delPointType(params) {
  return request({
    url: url + '/gh-point-type/delPointType',
    method: 'post',
    data: params
  })
}
/**
 * 点位类型管理
 * end
 */
/**
 * 母子点位管理
 * start
 */
//获取全部层级点位-树状结构
export function getPointLevelListTree(params) {
  return request({
    url: url + '/gh-point-level/getPointLevelListTree',
    method: 'post',
    data: params
  })
}
// 分页查询点位列表
export function getPointLevelListPage(params) {
  return request({
    url: url + '/gh-point-level/getPointLevelListPage',
    method: 'post',
    data: params
  })
}
// 获取点位
export function getPointLevelById(params) {
  return request({
    url: url + '/gh-point-level/getPointLevelById',
    method: 'get',
    params
  })
}
// 添加点位
export function addPointLevel(params) {
  return request({
    url: url + '/gh-point-level/addPointLevel',
    method: 'post',
    data: params
  })
}
// 修改点位
export function updatePointLevel(params) {
  return request({
    url: url + '/gh-point-level/updatePointLevel',
    method: 'post',
    data: params
  })
}
// 删除单个点位
export function delPointLevelById(params) {
  return request({
    url: url + '/gh-point-level/delPointLevelById',
    method: 'get',
    params
  })
}
// 获取用户
export function getIIamUseroAll(params) {
  return request({
    url: url + '/gh-point-level/getIIamUseroAll',
    method: 'get',
    params
  })
}

// 预览文件
export function preview(params) {
  return request({
    url: url + '/ghPoint/preview',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 获取图片
export function previewBase(params) {
  return request({
    url: url + '/gh-point-level/previewBase64New',
    method: 'get',
    params,
  })
}
/**
 * 母子点位管理
 * end
 */
/**
 * 点位人员管理
 * start
 */
// 分页查询点位与人员关系列表
export function getPointPersonListPage(params) {
  return request({
    url: url + '/gh-point-person/getPointPersonListPage',
    method: 'post',
    data: params
  })
}
// 获取所有的社区列表
export function getCommcommunityAll(params) {
  return request({
    url: url + '/gh-point-level/getCommcommunityAll',
    method: 'get',
    params
  })
}
// 根基社区ID获取网格列表
export function getblockAllByCommunityId(params) {
  return request({
    url: url + '/gh-point-level/getblockAllByCommunityId',
    method: 'get',
    params
  })
}
// 网格列表
export function getPointLevelThreeListById(params) {
  return request({
    url: url + '/gh-point-level/getPointLevelThreeListById',
    method: 'get',
    params
  })
}
// 添加点位与人员关系-批量
export function addBatchPointPerson(params) {
  return request({
    url: url + '/gh-point-person/addBatchPointPerson',
    method: 'post',
    data: params
  })
}
// 删除单个点位与人员关系
export function delPointPersonById(params) {
  return request({
    url: url + '/gh-point-person/delPointPersonById',
    method: 'get',
    params
  })
}
/**
 * 点位人员管理
 * end
 */
/**
 * 点位事项管理
 * start
 */
// 事项下的点位与标准配置关系只根据事项ID
export function relListByEventMangerId(params) {
  return request({
    url: url + '/gh-event-index-point-rel/relListByEventMangerId',
    method: 'get',
    params
  })
}
// 事项下的点位与标准配置关系
export function relList(params) {
  return request({
    url: url + '/gh-event-index-point-rel/relList',
    method: 'get',
    params
  })
}
// (单个)是否启用切换开关
export function relChangeState(params) {
  return request({
    url: url + '/gh-event-index-point-rel/changeState',
    method: 'get',
    params
  })
}
// (批量)是否启用切换开关
export function batchChangeState(params) {
  return request({
    url: url + '/gh-event-index-point-rel/batchChangeState',
    method: 'post',
    data: params
  })
}
/**
 * 点位事项管理
 * end
 */
/**
 * 点位部件管理
 * start
 */


// 分页查询点位部件列表
export function getPointPartsListPage(params) {
  return request({
    url: url + '/gh-point-parts/getPointPartsListPage',
    method: 'post',
    data: params
  })
}
// 添加点位部件
export function addPointParts(params) {
  return request({
    url: url + '/gh-point-parts/addPointParts',
    method: 'post',
    data: params
  })
}
// 修改点位部件
export function updatePointParts(params) {
  return request({
    url: url + '/gh-point-parts/updatePointParts',
    method: 'post',
    data: params
  })
}
// 删除点位部件
export function delPointParts(params) {
  return request({
    url: url + '/gh-point-parts/delPointParts',
    method: 'post',
    data: params
  })
}
// 获取点位部件
export function getPointPartsById(params) {
  return request({
    url: url + '/gh-point-parts/getPointPartsById',
    method: 'get',
    params
  })
}
/**
 * 点位部件管理
 * end
 */
// 分页查询点位类型列表
export function configPage(params) {
  return request({
    url: url + '/extend-user-admin-dept/configPage',
    method: 'post',
    data: params
  })
}
// 添加点位类型
export function delextend(params) {
  return request({
    url: url + '/extend-user-admin-dept/del',
    method: 'get',
    params
  })
}
// 维护一个用户的配置
export function userConfig(params) {
  return request({
    url: url + '/extend-user-admin-dept/userConfig',
    method: 'post',
    data: params
  })
}
// 批量结案
export function batchHandleByIds(params) {
  return request({
    url: url + '/extend-report-task/batchHandleByIds',
    method: 'post',
    data: params
  })
}

// 新增编辑网格
export function relEditPointAndDept(params) {
  return request({
    url: url + '/wgDiy/relEditPointAndDept',
    method: 'post',
    data: params
  })
}
// 编辑网格GenJson块数据
export function changePointGenJson(params) {
  return request({
    url: url + '/wgDiy/changePointGenJson',
    method: 'post',
    data: params
  })
}
// 网格删除
export function relDelPointAndDept(params) {
  return request({
    url: url + '/wgDiy/relDelPointAndDept',
    method: 'get',
    params
  })
}
// 查询网格点位genJson
export function getPointGeoJson(params) {
  return request({
    url: url + '/wgDiy/getPointGeoJson',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/point.js